"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsercryptUpsertStaticDataRequestGenderEnum = void 0;
exports.UsercryptUpsertStaticDataRequestGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other',
};
//# sourceMappingURL=usercrypt-upsert-static-data-request.js.map